export default __webpack_public_path__ + "media/vendors/app_store_download-e162efc9.svg";